import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const clients = [
  {
    name: "Kresus",
    badge: "Web3 SuperApp & Secure Wallet",
    description: "Architected core security protocols, Web3 transaction integrations, and native mobile features for the premium crypto superapp.",
    letter: "K",
    gradient: "from-blue-600 to-indigo-600 shadow-[0_0_12px_rgba(79,70,229,0.25)]"
  },
  {
    name: "GetWitIt",
    badge: "P2P Social Platform",
    description: "Designed the database schemas, real-time message dispatching, and high-concurrency event management backend engines.",
    letter: "G",
    gradient: "from-orange-500 to-red-500 shadow-[0_0_12px_rgba(239,68,68,0.25)]"
  },
  {
    name: "Mai AI",
    badge: "KMP Productivity Suite",
    description: "Engineered a Kotlin Multiplatform (KMP) companion app featuring local on-device neural inference and secure offline capabilities.",
    letter: "M",
    gradient: "from-emerald-500 to-teal-500 shadow-[0_0_12px_rgba(16,185,129,0.25)]"
  },
  {
    name: "MyHotSale",
    badge: "B2B E-Commerce Brokerage",
    description: "Optimized product inventory indexing, built real-time stock synchronization hooks, and automated broker alert systems.",
    letter: "M",
    gradient: "from-rose-500 to-pink-500 shadow-[0_0_12px_rgba(244,63,94,0.25)]"
  },
  {
    name: "Tulivu Properties",
    badge: "Real Estate Engine",
    description: "Created high-throughput property search mapping grids, advanced search filters, and location intelligence visualizations.",
    letter: "A",
    gradient: "from-violet-500 to-purple-600 shadow-[0_0_12px_rgba(168,85,247,0.25)]"
  }
]

const FeaturedClients = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

  return (
    <div className="w-full mx-auto px-6 py-12 lg:px-12 lg:py-20 text-slate-850 dark:text-white text-sm border-b border-slate-200 dark:border-slate-800/60" ref={ref}>
      <motion.div 
        className="text-center max-w-2xl mx-auto mb-16"
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <span className="text-forest dark:text-emerald-400 uppercase tracking-widest text-xs font-semibold">Client Engagements</span>
        <h2 className="text-3xl lg:text-4xl font-bold mt-3 bg-gradient-to-r from-slate-850 via-slate-700 to-slate-500 dark:from-white dark:via-emerald-100 dark:to-slate-400 bg-clip-text text-transparent">
          Trusted by Disruptive Tech Ventures
        </h2>
        <p className="text-slate-550 dark:text-slate-400 text-sm mt-4 font-light leading-relaxed">
          From decentralized finance and Web3 wallets to Kotlin Multiplatform AI systems and real-estate engines, we deliver hardened engineering solutions.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {clients.map((client, index) => (
          <motion.div
            key={client.name}
            className="flex flex-col p-6 rounded-2xl border border-slate-200 dark:border-slate-800/80 bg-white dark:bg-[#202222] hover:border-forest/30 dark:hover:border-emerald-500/30 transition-all duration-300 shadow-sm hover:shadow-md group"
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ y: -5 }}
          >
            <div className="h-12 flex items-center justify-start mb-4">
              <div className={`w-10 h-10 rounded-xl bg-gradient-to-tr ${client.gradient} flex items-center justify-center text-white font-bold text-lg`}>
                {client.letter}
              </div>
            </div>
            <div className="flex-grow flex flex-col justify-between">
              <div>
                <span className="text-[10px] text-forest dark:text-emerald-400 font-semibold uppercase tracking-wider block mb-1">
                  {client.badge}
                </span>
                <h3 className="font-semibold text-slate-800 dark:text-slate-100 text-base mb-2 group-hover:text-forest dark:group-hover:text-emerald-400 transition-colors duration-200">
                  {client.name}
                </h3>
                <p className="text-xs text-slate-500 dark:text-slate-400 font-light leading-relaxed">
                  {client.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default FeaturedClients
